import { Component } from '@angular/core';

@Component({
  selector: 'app-tax-document',
  templateUrl: './tax-document.component.html',
  styleUrls: ['./tax-document.component.scss'],
})
export class TaxDocumentComponent {
}
